import { render, staticRenderFns } from "./passCard.vue?vue&type=template&id=535f1332"
import script from "./passCard.vue?vue&type=script&lang=js"
export * from "./passCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports